import { Component } from '@angular/core';

@Component({
    selector: 'gea-svg-arrow-right',
    templateUrl: './arrow-right.component.html',
    standalone: false
})
export class ArrowRightComponent {

}
